<template>
  <div class="form__container">
    <header class="form__container__header">
      <h2 class="form__container__title">{{ title }}</h2>
    </header>

    <div class="form__container__content pt-1">
      <p class="form__container__desc mb-3">
        <span v-if="subtitle">{{ subtitle }}<br></span>
        <span v-html="text" />
      </p>

      <div class="text--center">
        <v-btn :href="hrefFile" color="#207347" rounded depressed large>
          <img src="@/assets/img/icons/icn_excel.svg" class="mr-2" style="max-height: 10%">
          <span style="color: #fff">{{ $t(`${namespace}.buttonDownloadLabel`)}}</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { formatNumber } from 'utils/functions'

export default {
  name: 'DownloadSpreadsheet',
  props: {
    kind: {
      type: String
    },
    maxLines: {
      type: Number,
      default: 1000
    },
    invalidFileType: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    title () {
      return !this.invalidFileType
        ? this.$t(`${this.namespace}.title`)
        : this.$t(`${this.namespace}.invalidFileTypeTitle`)
    },

    subtitle () {
      return !this.invalidFileType ? this.$t(`${this.namespace}.subtitle`) : ''
    },

    type () {
      if (this.kind === 'costCenter') {
        return this.$t('Common.costCenters')
      }

      if (this.kind === 'employee') {
        return this.$t('Common.employees')
      }

      if (this.kind === 'project') {
        return this.$t('Common.projects')
      }

      if (this.kind === 'incentives') {
        return this.$t('Common.incentives')
      }

      if (this.kind === 'approvePayment') {
        return this.$t('Common.charges')
      }

      return ''
    },

    text () {
      if (!this.invalidFileType) {
        return this.replaceText(this.$t(`${this.namespace}.text`))
      }

      return this.$t(`${this.namespace}.invalidFileTypeText`)
    },

    hrefFile () {
      if (this.kind === 'costCenter') {
        return 'https://99taxis-corporate.s3.amazonaws.com/centro_de_custos.xlsx'
      }

      if (this.kind === 'employee') {
        return 'https://99taxis-corporate.s3.amazonaws.com/colaboradores_v3.xlsx'
      }

      if (this.kind === 'project') {
        return 'https://99taxis-corporate.s3.amazonaws.com/projetos.xlsx'
      }

      if (this.kind === 'approvePayment') {
        return 'https://99taxis-corporate.s3.amazonaws.com/orders_status_to_update_template.xlsx'
      }

      if (this.kind === 'incentives') {
        return 'https://99taxis-corporate.s3.amazonaws.com/Incentivos.xlsx'
      }

      return ''
    }
  },
  data () {
    return {
      namespace: 'Views.BulkImportPage.downloadSpreadsheet'
    }
  },
  methods: {
    replaceText (str) {
      return str
        .replace(/\[MAX_LINES\]/g, formatNumber(this.maxLines))
        .replace(/\[TYPE\]/g, this.type.toLowerCase())
    }
  }
}
</script>
